import * as types from "@/store/constants/types";
import { sendErrorEventToWindow } from "@/utils/analytics";

export default {
  [types.RECEIVE_GX_SETTING_DATA](state: any, payLoad: any) {
    if (payLoad) {
      state.settingData = payLoad;
    } else {
      sendErrorEventToWindow("get_undefined_setting_data", payLoad);
    }
  },
  [types.UPDATE_LOCALIZE_PRICE](state: any, payLoad: any) {
    if (payLoad) {
      state.localizePrice = payLoad;
    } else {
      sendErrorEventToWindow("get_undefined_localize_data", payLoad);
    }
  },
  [types.UPDATE_INTERFACE_EXIST_STATE](state: any, payLoad: any) {
    state.judgeInterFaceExist = payLoad;
  },
  [types.UPDATE_SUB_SETTING](state: any, payLoad: any) {
    state.subsSetting[payLoad.key] = payLoad.value;
  },
  [types.UPDATE_TAKE_DOWN_UPDATE_NUMS](state: any) {
    state.takeDownOperateNums += 1;
  },
  [types.UPDATE_UNINSTALLED_LIST](state: any, payLoad: any) {
    state.unInstalledList = payLoad;
  },
  [types.UPDATE_STATE_FRONT](state: any, payLoad: any) {
    state.front = payLoad;
  }
};
